// removed by extract-text-webpack-plugin
module.exports = {"root":"root___2KxwS"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Merchant/Commodity/Detail/SaveOrUpdate.less
// module id = pEQr
// module chunks = 10 11